import styled from '@emotion/styled'

export const Cont = styled.div((props) => ({
  display: 'flex',
  flexDirection:'column',

  '.ReactTable .rt-tr':{
    cursor:'pointer'
  },
}))

